import { render } from "./ConfigNavigation.vue?vue&type=template&id=015325fe&scoped=true"
import script from "./ConfigNavigation.vue?vue&type=script&lang=js"
export * from "./ConfigNavigation.vue?vue&type=script&lang=js"

import "./ConfigNavigation.vue?vue&type=style&index=0&id=015325fe&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015325fe"]])

export default __exports__